import styled from 'styled-components'

type GridDivProps = {
  $gc?: string
  $gr?: string
  $jc?: string
  $ai?: string
}

export const GridDiv = styled('div')<GridDivProps>`
  grid-column: ${({ $gc }) => $gc || 'unset'};
  grid-row: ${({ $gr }) => $gr || 'unset'};
  display: flex;
  /* align-items: center;
  justify-content: center; */
  justify-content: ${({ $jc }) => $jc || 'center'};
  align-items: ${({ $ai }) => $ai || 'center'};
`
